import React, { useEffect, useState } from 'react';
import logoWhite from '../../assets/images/landing/logo-white.png';
import SectionLink from './SectionLink';
import { NAV_LINKS } from './landingContent';

const LandingNav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const close = () => setOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKey = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className={`lp-nav-wrap${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
      <nav className={`lp-nav${open ? ' is-open' : ''}`} aria-label="Primary">
        <SectionLink className="lp-logo" id="top" onClick={close}>
          <img src={logoWhite} alt="Elm Business Solutions" width="152" height="56" />
        </SectionLink>
        <button
          className="lp-nav-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="lp-nav-links"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen(!open)}
        >
          <span className="lp-nav-toggle-icon" aria-hidden="true" />
        </button>
        <div id="lp-nav-links" className="lp-nav-links">
          {NAV_LINKS.map((link) => (
            <SectionLink key={link.href} id={link.href.slice(1)} onClick={close}>
              {link.label}
            </SectionLink>
          ))}
          <SectionLink className="lp-btn lp-btn-primary lp-btn-sm" id="contact" onClick={close}>
            Book a Strategy Review <span aria-hidden="true">→</span>
          </SectionLink>
        </div>
      </nav>
    </div>
  );
};

export default LandingNav;
